const truncateString =(str, num)=> {
  if (str.length <= num) {
    return str
  }
  // Return str truncated with '..' concatenated to the end of str.
  return `${str.slice(0, num)  }..`
}
export default truncateString;
